import React from 'react';
import { NavLinks } from 'components/Navigation';

const Navigation = () => (
  <nav className="jg-background--white navigation">
    <NavLinks />
  </nav>
);

export default Navigation;
